import React, { useRef } from 'react';
import { List, Col, Row } from 'antd';
import { ConsoleSqlOutlined, UserOutlined } from '@ant-design/icons';

const stripHtmlTags = (html) => {
  const div = document.createElement('div'); 
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const MessageList = ({ messages, currentUser }) => {
  const messagesEndRef = useRef(null);

  if (!messages || messages.length === 0) {
    return <div>No messages to display</div>;
  }

  function HtmlContent({ content }) {
    return (
      <div>
        <style>
          {`
            div.HtmlContentWrapper p {
              margin: 0;
              padding: 0;
            }

            div.HtmlContentWrapper img {
              max-width: 100%;
              height: auto;
              max-height: 300px;
              display: block;
              margin: 10px 0;
            }
          `}
        </style>
        <div className="HtmlContentWrapper" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: '5px',
        paddingBottom: 0,
        background: '#fff',
        overflowY: 'scroll',
        maxHeight: '520px',
        minHeight: '480px',
        height: '100%',
        scrollbarWidth: 'thin',
        scrollbarColor: '#d4d4d4 transparent',
      }}
    >
      <style>
        {`
          div::-webkit-scrollbar {
            width: 1px;
          }
          div::-webkit-scrollbar-thumb {
            background: #d4d4d4;
            border-radius: 2px;
          }
          div::-webkit-scrollbar-track {
            background: transparent;
          }
        `}
      </style>
      <List
        dataSource={messages}
        renderItem={(msg) => (
          <List.Item
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              border: 'none',
              padding: 0,
            }}
          >
            {/* User Name and Logo in one line */}
            <Row style={{ width: '100%', alignItems: 'center' }}>
              <Col>
                <div
                  style={{
                    display: 'flex',
                    height: '100%',
                    flexShrink: 0,
                  }}
                >
                  <UserOutlined style={{ fontSize: '24px', color: '#888' }} />
                </div>
              </Col>
              <Col>
                <div
                  style={{
                    padding: '10px',
                    textAlign: 'left',
                  }}
                >
                  <span
                    style={{
                      fontWeight: '600',
                      color: 'black',
                      fontSize: '15px',
                    }}
                  >
                    {msg?.user?.id === currentUser.id ? currentUser.name : msg?.user?.name || ''}{' '}
                    <small
                      style={{
                        fontWeight: '400',
                        color: '#888',
                        fontSize: '13px',
                        marginLeft: '8px',
                      }}
                    >
                      {new Date(msg.created_at).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </small>
                  </span>
                </div>
              </Col>
            </Row>

            {/* Message Content Below */}
            <div
            style={{
              marginBottom: '5px', // Small margin from top
              paddingLeft: '32px', // Same left padding as Name
            }}
            >
              <HtmlContent content={msg.content} />
            </div>
          </List.Item>
        )}
      />
      {/* Scroll anchor */}
    </div>
  );
};

export default MessageList;
